module.exports = __webpack_public_path__ + "static/img/gaozhonglishi11.93336818.jpg";